/* ==============================================================================================
 * LOGIN DISCLAIMER
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var disclaimer = document.querySelector("[data-feature=loginDisclaimer]");

	if (!disclaimer) {
		return;
	}

	var showTrigger = document.querySelector("[data-disclaimer-show]");
	var hideTrigger = document.querySelector("[data-disclaimer-hide]");

	if (showTrigger) {
		Sushi.Events(showTrigger).on("click", function () {
			disclaimer.classList.remove("_dn");
		});
	}

	if (hideTrigger) {
		Sushi.Events(hideTrigger).on("click", function () {
			disclaimer.classList.add("_dn");
		});
	}

})(Sushi || (Sushi = {}));
